import { useEffect }        from "react";
import { Outlet }            from "react-router-dom";
import { SidebarProvider }   from "@/components/ui/sidebar";
import { AppSidebar }        from "@/components/AppSidebar";
import { TopBar }            from "@/components/TopBar";
import { PlatformStatusBanner } from "@/components/PlatformStatusBanner";
import { CommandPalette }    from "@/components/CommandPalette";
import { ErrorGuard }        from "@/system/errorGuard";
import { useSocketConnection }    from "@/hooks/useSocketConnection";
import { useObservabilitySocket } from "@/hooks/useObservabilitySocket";
import { initIncidentRealtime }   from "@/services/platformStatusService";
import { initWorkflowService }    from "@/services/workflowOrchestrationService";

export function Layout() {
  useSocketConnection();
  useObservabilitySocket();

  useEffect(() => initIncidentRealtime(), []);
  useEffect(() => initWorkflowService(),  []);

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full" style={{
        background: "radial-gradient(ellipse 120% 60% at 70% 0%, hsl(250 30% 8% / 0.8) 0%, hsl(228 14% 5%) 55%)",
        backgroundColor: "hsl(var(--background))",
      }}>

        <AppSidebar />

        {/* nv-safe-* keeps the chrome clear of the Android status bar and gesture handle. The
            gradient above still reaches the screen edge, so the insets add space without leaving
            a band of dead background. Both resolve to zero on the web, where env() has no insets. */}
        <div className="flex-1 flex flex-col min-w-0 nv-safe-top nv-safe-bottom">
          <PlatformStatusBanner />
          <TopBar />
          <a href="#main-content" className="nv-skip-link">Skip to main content</a>
          <main id="main-content" tabIndex={-1} className="flex-1 overflow-auto p-4 sm:p-6 lg:p-8">
            <div className="max-w-7xl mx-auto">
              {/* Route-level isolation - a crashing page cannot take down the shell */}
              <ErrorGuard name="route">
                <Outlet />
              </ErrorGuard>
            </div>
          </main>
        </div>

      </div>

      {/* ACU warnings live only inside the project workspace (WorkspaceLayout),
          where building happens. They are not shown on the dashboard or other
          general pages. */}
      <CommandPalette />
    </SidebarProvider>
  );
}
